export default class CollectionFilter {
  constructor({ el, isLargeQuery }) {
    this.el = el;
    this.isLargeQuery = isLargeQuery;

    this.filterToggles = Array.from(this.el.querySelectorAll('.filter-toggle'));

    // actual filtering
    this.form = this.el.querySelector('form');
    this.checkboxes = Array.from(this.el.querySelectorAll('.filter-checkbox'));
    this.containerElString = this.el.getAttribute('data-container-el');
    this.productsListContainer = document.getElementById(this.containerElString);
    this.productData = this.productsListContainer.querySelector('.product-data');
    this.searchParamsInitial = window.location.search.slice(1);
    this.searchParamsPrev = window.location.search.slice(1);
    this.resetButton = this.el.querySelector('.reset-button');
    this.productCount = this.el.querySelector('.product-count');
    this.filterType = this.el.getAttribute('data-type');
    this.sectionToRender = this.filterType === 'collection' ? 'main-collection-list' : 'main-search-list';

    this.init();
  }

  init() {
    this.filterToggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.el.classList.contains('active')) {
          this.close();
        } else {
          this.open();
        }
      });
    });

    // click outside to close
    document.addEventListener('click', (e) => {
      if (!this.el.contains(e.target)) {
        this.close();
      }
    });

    // filter checkboxes
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const params = this.getSearchParams();

        this.renderPage(params);
      });
    });

    this.resetButton.addEventListener('click', async (e) => {
      e.preventDefault();
      await this.renderPage(false, true, true);
    });

    window.addEventListener('popstate', this.onHistoryChange.bind(this));
  }

  open() {
    this.el.classList.add('active');
  }

  close() {
    this.el.classList.remove('active');
  }

  async renderPage(searchParams, updateFilters = false, updateUrl = true) {
    console.log(searchParams);
    // set previous search params
    this.searchParamsPrev = searchParams;

    this.productData = this.productsListContainer.querySelector('.product-data');
    this.productData.style.opacity = '.3';
    this.productCount.innerHTML = 'Loading...';

    if (updateUrl) this.updateUrl(searchParams);

    // check if search params is empty
    if (!searchParams) {
      this.el.classList.add('hide-reset');
    } else {
      this.el.classList.remove('hide-reset');
    }

    // update form filters
    if (updateFilters) {
      this.checkboxes.forEach((checkbox) => {
        const paramChecker = checkbox.dataset.paramChecker;

        if (searchParams?.filterParams && searchParams.filterParams.includes(paramChecker)) {
          checkbox.checked = true;
        } else {
          checkbox.checked = false;
        }
      });
    }

    // get filter url
    const url = `${window.location.pathname}?${searchParams.q ? `q=${searchParams.q}&` : ''}section_id=${
      this.sectionToRender
    }${searchParams.filterParams ? `&${searchParams.filterParams}` : ''}`;

    // fetch new products list via section rendering api
    await fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const resultsMarkup = new DOMParser().parseFromString(html, 'text/html');
        const productHTML = resultsMarkup.querySelector('#products-list-container').innerHTML;
        const productCount = parseInt(resultsMarkup.querySelector('.product-data').dataset.count);

        // update products list
        this.productsListContainer.innerHTML = productHTML;
        this.productCount.innerHTML = productCount === 1 ? '1 Item' : `${productCount} Items`;
      });
  }

  getSearchParams() {
    // check if there is a 'q' search param in url
    const url = new URL(window.location);
    const searchParams = url.searchParams;
    const q = searchParams.get('q');

    const formData = new FormData(this.form);

    return {
      q,
      filterParams: new URLSearchParams(formData).toString(),
    };
  }

  updateUrl(searchParams) {
    if (searchParams) {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}?${
          searchParams.q ? `q=${searchParams.q}${searchParams.filterParams ? '&' : ''}` : ''
        }${searchParams.filterParams}`,
      );
    } else {
      history.pushState({}, '', `${window.location.pathname}`);
    }
  }

  onHistoryChange(e) {
    const searchParams = e.state ? e.state.searchParams : this.searchParamsInitial;
    if (searchParams === this.searchParamsPrev) return;
    this.renderPage(searchParams, true, false);
  }
}
